import React, { useContext } from 'react'
import { ChangePresentContext, OpsPlanContext } from '../../../SingleEvent'
import { Grid } from '@mui/material'
import PresetsTextField from '../../../../../../components/Forms/PresetsTextField'

const ResourcesSummary = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <PresetsTextField
        label="Resources Summary"
        value={opsPlan?.resourcesSummary}
        suggestionPath="opsPlan.resourcesSummary"
        suggestionLabel="Resource summaries from templates"
        InputLabelProps={{
          shrink: opsPlan?.resourcesSummary ? true : false,
        }}
        setValue={(newValue) => {
          setOpsPlan((prev) => ({
            ...prev,
            resourcesSummary: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        fullWidth
        minRows={2}
        multiline
      />
    </Grid>
  )
}

export default React.memo(ResourcesSummary)
